export enum VerseTabUnderlineTypographyEnum {
  SUBTITLE_1 = 'subtitle1',
  BUTTON_LARGE = 'buttonLarge',
}
